import { defineComponent as _defineComponent } from 'vue'
import BButton from 'JS/components/BButton.vue';
import Icon from 'JS/components/Icon.vue';
import InstallationQuoteLineItem from './InstallationQuoteLineItem.vue';
import InstallationQuoteOptionalLineItem from './InstallationQuoteOptionalLineItem.vue';
import JoinRewardsCallout from 'JS/components/order/JoinRewardsCallout.vue';
import PromoOfferDiscountLine from 'JS/components/order/PromoOfferDiscountLine.vue';
import RewardsAndOffers from 'JS/cart/components/RewardsAndOffers.vue';
import RewardsBadgeWithColor from 'JS/components/RewardsBadgeWithColor.vue';
import RoadHazardProtectionModal from '../RoadHazardProtectionModal.vue';
import TransitionExpand from 'JS/components/transitions/TransitionExpand.vue';
import windowData from 'JS/global/window-data';
import { computed, ref } from 'vue';
import { getOfferIndicatorFromPromoOfferBucket, OfferBucketLabelMap, OfferBucketToDisplayTypeMap } from 'JS/helpers/promo-helpers';
import { IAutomotiveWorkOrderQuoteSummary } from 'JS/types/automotive/WorkOrderQuote';
import { PromoOfferBucket } from 'JS/types/Promo';


export default /*#__PURE__*/_defineComponent({
  __name: 'InstallationQuote',
  props: {
    qty: null,
    blainNumber: null,
    quote: null,
    selectedAddOns: null,
    loading: { type: Boolean },
    loadingComplete: { type: Boolean },
    maxQuantityExceeded: { type: Boolean }
  },
  emits: ["check-item", "more-info", "submit", "open-rewards-side-menu"],
  setup(__props: any, { emit }: { emit: ({
	(e: 'check-item', blainNumber: string): void;
	(e: 'more-info', $event: any): void;
	(e: 'submit', $event: Event): void;
	(e: 'open-rewards-side-menu', sideMenu: "rewards" | "login" | "change-store"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	qty: number;
	blainNumber: string;
	quote: IAutomotiveWorkOrderQuoteSummary;
	selectedAddOns: Set<string>;
	loading: boolean;
	loadingComplete: boolean;
	maxQuantityExceeded: boolean;
}





const showHazardProtectionModal = ref(false);
const potentialRewardsString = computed(() => props.quote.estimatedRewardsPoints.toFixed(2).toString());

const discountsOpen = ref(false);
const toggleDiscounts = () => {
	discountsOpen.value = !discountsOpen.value;
};

const formatDisplayPrice = (price: number) => {
	if (props.loading) {
		return "-";
	}

	return formatPrice(price);
};

// todo these are generic "available offer" cards
const promosWithoutDollarAmounts = computed(
	() => props?.quote?.promos?.filter(p => p.promoType === PromoOfferBucket.MailInRebate)
		.map(p => ({
			...p,
			indicator: getOfferIndicatorFromPromoOfferBucket(p.promoType),
			label: OfferBucketLabelMap[p.promoType],
		})) ?? []
);

const promos = computed(() => props.quote?.promos?.filter(p => p.promoType !== PromoOfferBucket.MailInRebate && p.promoType !== PromoOfferBucket.Bounceback).map(promo => ({
	...promo,
	promoType: OfferBucketToDisplayTypeMap[promo.promoType],
})));

function formatPrice(price: number): string {
	return '$' + Math.abs(price).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function handleJoinRewardsClick() {
	if (windowData.customer != null) {
		emit('open-rewards-side-menu', 'rewards');
	} else {
		emit('open-rewards-side-menu', 'login');
	}
}


return { __sfc: true,props, emit, showHazardProtectionModal, potentialRewardsString, discountsOpen, toggleDiscounts, formatDisplayPrice, promosWithoutDollarAmounts, promos, formatPrice, handleJoinRewardsClick, BButton, Icon, InstallationQuoteLineItem, InstallationQuoteOptionalLineItem, JoinRewardsCallout, PromoOfferDiscountLine, RewardsBadgeWithColor, RoadHazardProtectionModal, TransitionExpand }
}

})